import { atom, PrimitiveAtom } from 'jotai'

import { store } from '@/store'

export const mobileChatSettingsDrawerAtom: PrimitiveAtom<boolean> = atom(false)
export const mobileChatHistoryDrawerAtom: PrimitiveAtom<boolean> = atom(false)
export const mobileDocumentsHistroyDrawerAtom: PrimitiveAtom<boolean> = atom(false)
export const mobileTranslateHistroyDrawerAtom: PrimitiveAtom<boolean> = atom(false)

export const toggleChatSettingsMobileDrawer = () => {
    store.set(mobileChatSettingsDrawerAtom, !store.get(mobileChatSettingsDrawerAtom))
}

export const toggleChatHistoryMobileDrawer = () => {
    store.set(mobileChatHistoryDrawerAtom, !store.get(mobileChatHistoryDrawerAtom))
}

export const toggleDocumentsHistoryMobileDrawer = () => {
    store.set(mobileDocumentsHistroyDrawerAtom, !store.get(mobileDocumentsHistroyDrawerAtom))
}

export const toggleTranslateHistoryMobileDrawer = () => {
    store.set(mobileTranslateHistroyDrawerAtom, !store.get(mobileTranslateHistroyDrawerAtom))
}
